import { jsx as m } from "react/jsx-runtime";
import p from "react";
import { B as i } from "../Box-a4eeb4ec.js";
import "../index-057d60ee.js";
import "../_commonjsHelpers-c5d32002.js";
import "../identifier-2b569a98.js";
import "../generateUtilityClasses-b12a03ea.js";
import "../createTheme-ef7fa3a1.js";
import "../objectWithoutPropertiesLoose-1e2b28af.js";
import "../extends-e3d0fd9d.js";
import "../extends-0a3e0827.js";
import "../clsx-0c6e471a.js";
import "../extendSxProp-10687d60.js";
import "@emotion/styled";
import "@emotion/react";
import "../GlobalStyles-bdd9f9fb.js";
import "../useTheme-89580aa5.js";
import "../useThemeWithoutDefault-9240f28c.js";
const a = p.forwardRef(({ children: o, ...r }, t) => /* @__PURE__ */ m(i, { ref: t, ...r, children: o }));
a.displayName = "Box";
export {
  a as default
};
//# sourceMappingURL=Box.js.map
